import { api, Auth } from "@services";

export const updateFileApi = formData => api.post(`/v1/upload-file`, formData);
export const removeFileApi = (id, assistId) => api.post(`/v1/remove-file`, {id, assistId});
